import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const TrashCanDeleteIcon = ({
  color = colors.black,
  className,
  onClick,
  style,
  size = 24,
}: IProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      {...style}
    >
      <path
        id="Path"
        d="M6 7.66099H18"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Path_2"
        d="M17.1429 7.66016V17.0887C17.1429 18.0359 16.3757 18.803 15.4286 18.803H8.57146C7.62432 18.803 6.85718 18.0359 6.85718 17.0887V7.66016"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Path_3"
        d="M14.5711 4.87584H9.42822"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Path_4"
        d="M10.2857 11.0898V15.3756"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Path_5"
        d="M13.7142 11.0898V15.3756"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TrashCanDeleteIcon;
